import { Grid } from '@forgeglobal/design-framework';
import { Persona } from '@tcs/client-portal-api/types/Persona';
import useSession from '@tcs/client-portal-common/hooks/useSession';
import DropdownField from '@tcs/common/components/atoms/DropdownField';
import { Field } from '@tcs/common/components/atoms/Form';
import SsnTextField from '@tcs/common/components/atoms/SsnTextField';
import TextField from '@tcs/common/components/atoms/TextField';

export const EntityBeneficiaryForm = ({ isPrimary }) => {
  const {
    claims: { clientPortalPersona: persona },
  } = useSession();

  const options = [
    {
      label: 'Estate',
      value: 'Estate',
    },
    {
      label: 'Trust',
      value: 'Trust',
    },
    {
      label: 'Other (Charities, Non-Profits, etc.)',
      value: 'Other',
    },
    {
      label: 'Notarized Estate',
      value: 'Notarized Estate',
    },
    {
      label: 'Notarized Trust',
      value: 'Notarized Trust',
    },
    {
      label: 'Notarized Other',
      value: 'Notarized Other',
    },
  ];

  const getRelationshipOptions = () => {
    if (persona !== Persona.Admin || !isPrimary) {
      return options.filter(
        (option) => option.value.startsWith('Notarized') === false,
      );
    }
    return options;
  };

  return (
    <>
      <Grid item data-test-id="beneficiary-form-relationship">
        <Field
          name="entityType"
          render={(props) => {
            const isNotaryBeneficiary =
              props.input.value.startsWith('Notarized');
            return (
              <DropdownField
                label="Entity type"
                required
                {...props}
                options={getRelationshipOptions()}
                disabled={isNotaryBeneficiary && persona !== Persona.Admin}
              />
            );
          }}
        />
      </Grid>
      <Grid item data-test-id="beneficiary-form-entity-name">
        <Field
          name="entityName"
          required
          render={(props) => (
            <TextField data-private label="Name" {...props} normalize />
          )}
        />
      </Grid>
      <Grid item data-test-id="beneficiary-form-tax-id">
        <Field
          name="taxIdentificationNumber"
          render={(props) => (
            <SsnTextField
              data-private="lipsum"
              label="Tax identification number (TIN)"
              {...props}
            />
          )}
        />
      </Grid>
    </>
  );
};

export default EntityBeneficiaryForm;
